import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const followersEvolutionConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.tiktok.followers_evolution',
    id: 'followers_evolution',
    icon: {
        name: 'followers',
        style: colors.blue
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    tooltip: 'kpi.tiktok.tooltip_followers_evolution',
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: DefaultLoader,
    element: KPIDefault,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
